module.exports = __webpack_public_path__ + "static/media/out-of-state-xl.71c56814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/out-of-state-xl.jpg
// module id = 414
// module chunks = 13